module.exports = __webpack_public_path__ + "static/media/minus-light.e2afbba3.svg";